// SPDX-License-Identifier: AGPL-3.0-or-later

import PremiumState from '@app/features/premium/state/PremiumState';
import Users from '@app/features/user/state/Users';

// Micup: a renewing Plus is managed and cancelled in the settings, so its account keeps the Plus tab there instead of
// being sent to the Plus page.
export function showsSubscriptionSettings(): boolean {
	return PremiumState.hasLivePaddleSubscription(Users.getCurrentUser()?.id);
}
